import firebase from "firebase/compat/app";
import "firebase/compat/functions";
import "firebase/compat/firestore";
import "firebase/compat/storage";
import "firebase/compat/auth";
import "firebase/compat/database";

import { brand } from "@/brandVariables/getBandVariables";

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FB_CNFG_API_KEY,
  authDomain: import.meta.env.VITE_FB_CNFG_DOMAIN,
  databaseURL: import.meta.env.VITE_FB_CNFG_DATABASE_URL,
  projectId: import.meta.env.VITE_FB_CNFG_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FB_CNFG_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FB_CNFG_SENDER_ID,
  appId: import.meta.env.VITE_FB_CNFG_APP_ID,
};

// Initialize Firebase
export const firebaseApp = firebase.initializeApp(firebaseConfig);

export const firestore = firebaseApp.firestore();
export const storage = firebaseApp.storage();
export const database_1 = firebaseApp.database();
export const cacheDatabase = firebaseApp.database(
  "https://spike-cache.europe-west1.firebasedatabase.app"
);

// auth
export const auth = firebaseApp.auth();
auth.tenantId = brand?.tenantId || brand?.client || "";

export const GoogleAuthProvider_ID =
  firebase.auth.GoogleAuthProvider.PROVIDER_ID;
export const EmailAuthProvider_ID = firebase.auth.EmailAuthProvider.PROVIDER_ID;
export const PhoneAuthProvider_ID = firebase.auth.PhoneAuthProvider.PROVIDER_ID;
//Classes and Types
export type FirebaseUser = firebase.User;
export const FieldValue = firebase.firestore.FieldValue;
export const timestamp = firebase.firestore.Timestamp;
const timestampNow = timestamp.now();
export type Timestamp = typeof timestampNow;
export type FirebaseCollectionReference =
  firebase.firestore.CollectionReference<firebase.firestore.DocumentData>;
export type QuerySnapshot = firebase.firestore.QuerySnapshot;
export type FirestoreQuery =
  firebase.firestore.Query<firebase.firestore.DocumentData>;
export type FirestoreQuerySnapshotDoc =
  firebase.firestore.QueryDocumentSnapshot<firebase.firestore.DocumentData>;

//functions
export const functions = (functionName: string) =>
  firebase.app().functions("europe-west1").httpsCallable(functionName);
